var exports = {
  "kL": "xdde3148b--c4720c--container",
  "iW": "xdde3148b--c4720c--main",
  "HU": "xdde3148b--c4720c--aside",
  "_R": "xdde3148b--c4720c--close-button",
  "q9": "xdde3148b--c4720c--price",
  "cL": "xdde3148b--c4720c--builder",
  "o1": "xdde3148b--c4720c--actions",
};

module.exports = exports;
